import React, { useState, useContext, useEffect, useCallback } from 'react';
import { ContextoFinanceiro } from '../../../services/financeiro';
import { Spinner } from '../../StyledComponent';
import Close from '../../Reutilizaveis/CloseButton';
import ParcelasSelecionadas from './ParcelasSelecionadas';
import Calendario from '../../Reutilizaveis/Calendar-master';
import Format from '../../../Utils/formatCurrent';
import { formatData } from '../../../Utils/formatDate';
import ResumoTotais from './ResumoTotais';
import ModalBanner from '../../ModalBanner';

import ExibirBoletoGerado from './ExibirBoletoGerado';

import { ReactComponent as ErrorAlert } from '../../../assets/novosicones/Financeiro/error_black_24dp.svg';

import verificaSeParcelaAtrasada from '../../../Utils/checkIfBillIsLate';

import { BannerGerarBoleto, ContainerGerarBoleto, BannerTitle } from './styles';

import './styles.scss';

import { useHistory } from 'react-router-dom';

const GerarBoleto = ({
  setGerarBoleto,
  parcelasSelecionadas,
  setParcelasSelecionadas,
  loading,
  setLoading,
  consultaDescontoAntecipacao,
  dadosDesconto,
  formataData,
  dataParaAgendar,
  setDataParaAgendar,
  contratoSelecionado,
  setParcelasAPagar,
  setParcelasAPagarComBoleto,
  parcelasSelecionadasOriginal,
  setParcelasSelecionadasOriginal,
  erroConsultarDescontoParcela,
  setErroConsultarDescontoParcela,
  tema,
  parcelasAPagar,
}) => {
  const [showCalendario, setShowCalendario] = useState(true);

  const [haParcelaVencida, setHaParcelaVencida] = useState('');

  const [dadosAcrescimos, setDadosAcrescimos] = useState({});

  const [showBanner, setShowBanner] = useState(false);

  const [erroEmpresaDiferente, setErroEmpresaDiferente] = useState(false);

  const [error, setError] = useState(false);

  const [exibirBoletoGerado, setExibirBoletoGerado] = useState(false);

  const [disabledDay, setDisabledDay] = useState(false);

  const {
    getParcelasAReceberNoUAU,
    postFinanceiroGerarBoleto,
    getParcelasAPagar,
  } = useContext(ContextoFinanceiro);
  const history = useHistory();

  useEffect(() => {
    checkIfDueDate();

    setParcelasSelecionadasOriginal(parcelasSelecionadas);

    calcDadosParcelas(parcelasSelecionadas);

    history.replace('/financeiro/#modal-boleto');

    return () => {
      history.replace('/financeiro');
    };
  }, []);

  useEffect(() => {
    if (erroConsultarDescontoParcela) {
      setError(true);
      setShowBanner(true);
    }
  }, [erroConsultarDescontoParcela]);

  function checkIfDueDate() {
    parcelasSelecionadas.sort(compare);

    for (let a of parcelasSelecionadas) {
      if (verificaSeParcelaAtrasada(a.parcela.dataVencimento)) {
        setHaParcelaVencida(true);
        break;
      } else {
        setHaParcelaVencida(false);
      }
    }
  }

  function compare(a, b) {
    return new Date(a.parcela.dataVencimento.split('T')[0]).getTime() >
      new Date(b.parcela.dataVencimento.split('T')[0]).getTime()
      ? 1
      : -1;
  }

  async function setDataAlterada(dataSelecionada) {
    setLoading(true);
    setDisabledDay(true);

    let updated = await getBuscarParcelasUAU(dataSelecionada);

    if (updated) {
      calcDadosParcelas(updated, 'uau');
      // if (updated != undefined) {
      await consultaDescontoAntecipacao(formataData(dataSelecionada), updated);
      setLoading(false);
    } else {
      setError(true);
      setShowBanner(true);
    }

    setDisabledDay(false);
  }

  const getBuscarParcelasUAU = async (dataSelecionada) => {
    const updatedBills = [];

    const tempEmpresas = [];

    for (let empresaParcelas of parcelasSelecionadas) {
      tempEmpresas.push(empresaParcelas.parcela.empresa);
    }

    var empresasFinal = [...new Set(tempEmpresas)];

    var response = [];
    try {
      for (let empresa of empresasFinal) {
        let dadosContaUsuario = {
          Empresa: empresa,
          Obra: parcelasSelecionadas[0].parcela.obra,
          num_ven: parcelasSelecionadas[0].parcela.numeroVenda,
          Data_calculo: formataData(dataSelecionada),
        };
        response.push(...(await getUau(dadosContaUsuario)));
      }

      for (let bill of parcelasSelecionadas) {
        const updatedData = response.find(
          (b) =>
            b.numParc_Prc == bill.parcela.numeroParcela &&
            b.numParcGer_Prc == bill.parcela.numeroParcelaGeral &&
            b.tipo_Prc == bill.parcela.tipoParcela
        );

        updatedBills.push({ ...bill, ...updatedData });
      }

      setParcelasSelecionadas(updatedBills);
      return updatedBills;
    } catch (error) {
      setError(true);
    }
  };

  async function getUau(dadosContaUsuario) {
    try {
      return await getParcelasAReceberNoUAU(dadosContaUsuario);
    } catch {
      setError(true);
      setShowBanner(true);
    }
  }

  async function gerarBoleto() {
    setLoading(true);
    setDisabledDay(true);

    let dadosParcelas = {
      parcelas: [],
      data_calculo: '',
    };

    let idsVenda = {
      IdVenda:
        contratoSelecionado?.idVenda || contratoSelecionado?.contrato?.idVenda,
      IdVendaCarteira:
        contratoSelecionado?.idVendaCarteira ||
        contratoSelecionado?.contrato?.idVendaCarteira,
    };

    for (let parc of parcelasSelecionadas) {
      dadosParcelas.parcelas.push({
        idReceber: parc.parcela.idReceber,
        empresa_reaj: parc.parcela.empresa,
        obra_reaj: parc.parcela.obra,
        numVenda_reaj: parc.parcela.numeroVenda,
        numParc_reaj: parc.parcela.numeroParcela,
        tipo_reaj: parc.parcela.tipoParcela,
        numParcGer_reaj: parc.parcela.numeroParcelaGeral,
        valorDescAnt_reaj: parc.totalDesconto ?? 0,
        valor_reaj: parc.parcela.valorReajustado - (parc.totalDesconto ?? 0),
      });
    }

    try {
      dadosParcelas = {
        ...dadosParcelas,
        data_calculo: formataData(dataParaAgendar),
        valorBoleto: parseFloat(
          (dadosDesconto.totalBoleto - dadosDesconto.totalDesconto)?.toFixed(2)
        ),
      };

      await postFinanceiroGerarBoleto(dadosParcelas);

      let resultGetParcelasPagar = await getParcelasAPagar(idsVenda);

      const { parcelas = [] } = resultGetParcelasPagar.data;

      setParcelasAPagar(parcelas);
      setParcelasAPagarComBoleto(parcelas);
      setLoading(false);
      // setGerarBoleto(false);
      setExibirBoletoGerado(true);
      // setParcelasSelecionadas([]);
    } catch (error) {
      if (
        error.request?.response.includes(
          'Só é permitido gerar boleto parcial de uma única empresa, obra e venda.'
        )
      ) {
        setErroEmpresaDiferente(true);
      }
      setLoading(false);
      setError(true);
      setShowBanner(true);
    }
  }

  function calcDadosParcelas(parcelas, uau) {
    let totalJuros = 0;
    let totalMulta = 0;
    let totalAcrescimos = 0;

    if (uau == undefined) {
      for (let p of parcelas) {
        if (
          new Date(p.parcela.dataVencimento).getTime() < new Date().getTime()
        ) {
          totalJuros += p.parcela.vlJuros + p.parcela.vlJurosAtraso;
          totalMulta += p.parcela.vlMulta;
          totalAcrescimos += p.parcela.vlReajuste + p.parcela.vlCorrecaoAtraso;
        }
      }
      setDadosAcrescimos({ totalJuros, totalMulta, totalAcrescimos });
    } else {
      for (let p of parcelas) {
        if (
          new Date(p.parcela.dataVencimento).getTime() < new Date().getTime()
        ) {
          totalJuros += p.vlrJurosReal + p.vlrJurosAtraso;
          totalMulta += p.valorMulta;
          totalAcrescimos += p.vlrCorrecao + p.vlrCorrecaoAtra;
        }
      }
      setDadosAcrescimos({ totalJuros, totalMulta, totalAcrescimos });
    }
  }

  // esta função verifica se, dentre as parcelas selecionadas, existe alguma parcela que vence no mês corrente, se sim, só deixa gerar boleto na data de vencimento da parcela do mês corrente
  const verificaParcelaMes = useCallback(() => {
    let now = new Date();

    let parcelaUnicaVencendoNoMes = false;

    let parcelasVencendoNoMes = parcelasSelecionadas.filter((par) => {
      let tempDate = new Date(par.parcela.dataVencimento);

      return (
        tempDate.getFullYear() == now.getFullYear() &&
        tempDate.getMonth() == now.getMonth()
      );
    });

    if (
      parcelasVencendoNoMes?.length > 0 &&
      !verificaSeParcelaAtrasada(
        parcelasVencendoNoMes[0].parcela.dataVencimento
      )
    ) {
      parcelaUnicaVencendoNoMes = true;
      setDataParaAgendar(parcelasVencendoNoMes[0].parcela.dataVencimento);
    }

    return { parcelasVencendoNoMes, parcelaUnicaVencendoNoMes };
  });

  const mensagemCalendario = useCallback(() => {
    if (
      // parcelasSelecionadas?.length === 1 &&
      verificaParcelaMes().parcelasVencendoNoMes?.length
    ) {
      return `*Uma das parcelas selecionadas vence dentro do mês corrente e seu boleto só pode ser gerado em sua data atual de vencimento.`;
    } else if (
      parcelasSelecionadas.findIndex(
        (parc) =>
          new Date(parc.parcela.dataVencimento).getTime() > new Date().getTime()
      ) === 0
    ) {
      return `*Fique atento, o pagamento antecipado de uma parcela pode gerar desconto proporcional de juros e de outros encargos.`;
    } else if (
      parcelasSelecionadas.findIndex(
        (parc) =>
          new Date(parc.parcela.dataVencimento).getTime() < new Date().getTime()
      ) === 0
    ) {
      return `*Uma das parcelas selecionadas está vencida e seu boleto só pode ser gerado nas datas em destaque.`;
    }
  });

  if (exibirBoletoGerado)
    return (
      <ExibirBoletoGerado
        parcelasAPagar={parcelasAPagar}
        parcelasSelecionadas={parcelasSelecionadas}
        setParcelasSelecionadas={setParcelasSelecionadas}
        tema={tema}
        setExibirBoletoGerado={setExibirBoletoGerado}
        setGerarBoleto={setGerarBoleto}
        contratoSelecionado={contratoSelecionado}
      />
    );

  return (
    <>
      <BannerGerarBoleto>
        <ContainerGerarBoleto>
          <BannerTitle color={tema.primaryColor}>
            <h1>Emissão de boleto</h1>

            <Close
              tamanho={'30px'}
              marginRight={0}
              onClick={() => {
                setParcelasSelecionadas(parcelasSelecionadasOriginal);
                setGerarBoleto(false);
              }}
              id='btnFecharModalGerarBoleto'
              disabled={loading}
            />
          </BannerTitle>

          <div
            className='centralized mobile'
            style={{
              width: '100%',
              alignItems: 'flex-start',
            }}
          >
            <div
              style={{ width: '50vw', height: '100%' }}
              className='mobile-sections'
            >
              <ParcelasSelecionadas
                parcelasSelecionadas={parcelasSelecionadas}
                setGerarBoleto={setGerarBoleto}
                tema={tema}
                dadosDesconto={dadosDesconto}
                parcelasVencidas={haParcelaVencida}
                loading={loading}
              />
            </div>
            <div
              style={{ width: '50%', height: '100%' }}
              className='mobile-sections'
            >
              <span
                style={{
                  color: '#4D4D4D',
                  fontSize: '14px',
                  marginBottom: '8px',
                  display: 'block',
                }}
              >
                Data de vencimento:
              </span>
              {haParcelaVencida !== '' && (
                <Calendario
                  setShowCalendario={setShowCalendario}
                  setDataParaAgendar={setDataParaAgendar}
                  data={dataParaAgendar}
                  showCalendario={showCalendario}
                  parcelasSelecionadas={parcelasSelecionadas}
                  largura={'300px'}
                  altura={'auto'}
                  setDataAlterada={setDataAlterada}
                  gerarBoleto
                  haParcelaVencida={haParcelaVencida}
                  parcelaUnicaVencendoNoMes={
                    verificaParcelaMes().parcelaUnicaVencendoNoMes
                  }
                  mensagemCalendario={mensagemCalendario}
                  disabledDayOnClick={disabledDay}
                />
              )}
            </div>
          </div>

          {error && (
            <ModalBanner showBanner={showBanner} setShowBanner={setShowBanner}>
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: 8,
                  position: 'relative',
                  padding: '20px 16px',
                  boxShadow: '0px 0px 10px #4d4d4d',
                  width: '85%',
                  margin: 'auto',
                }}
                className='containerBanner centralized-column'
              >
                <>
                  <p
                    style={{
                      textAlign: 'left',
                      fontSize: '18px',
                      color: 'rgb(77, 77, 77)',
                      fontWeight: '900',
                      margin: '0',
                      marginBottom: 8,
                    }}
                  >
                    Solicitação inválida
                  </p>
                  <div className='centralized-flex-start' style={{ gap: 12 }}>
                    <span>
                      <ErrorAlert />
                    </span>
                    <div className='centralized-column'>
                      <p
                        style={{
                          textAlign: 'left',
                          fontSize: '14px',
                          color: 'rgb(77, 77, 77)',
                          fontWeight: '500',
                          margin: '0',
                        }}
                      >
                        {erroEmpresaDiferente &&
                          `As parcelas selecionadas não permitem a geração de boleto agrupado. Favor gerar o boleto individual, selecionando uma parcela por vez.`}
                        {error &&
                          !erroEmpresaDiferente &&
                          `No momento o servidor não pode ou não irá processar a
                        requisição, tente novamente ou entre em contato com
                        nossa central de relacionamento para mais informações.`}
                        {erroConsultarDescontoParcela &&
                          `No momento o servidor não pode ou não irá processar a
                        requisição, tente novamente ou entre em contato com
                        nossa central de relacionamento para mais informações.`}
                      </p>
                    </div>
                  </div>
                  <span
                    style={{
                      position: 'absolute',
                      right: -15,
                      top: -12,
                      cursor: 'pointer',
                    }}
                    id='btnEntendiAlteracaoPerfil'
                    onClick={(e) => {
                      e.preventDefault();
                      // setShowBanner(!showBanner);
                      setErroEmpresaDiferente(false);
                      setError(false);
                      setShowBanner(false);
                      setErroConsultarDescontoParcela(false);
                      setGerarBoleto(false);
                    }}
                  >
                    <Close corBackground='#ffffff' />
                  </span>
                </>
              </div>
            </ModalBanner>
          )}

          <>
            {(loading || !dataParaAgendar) && (
              <div
                style={{ height: '110px', width: '100%' }}
                className='centralized'
              >
                <Spinner size='14px' />
              </div>
            )}

            {!loading && dataParaAgendar && (
              <>
                <ResumoTotais
                  dadosDesconto={dadosDesconto}
                  dadosAcrescimos={dadosAcrescimos}
                />
                <div className='centralized-space-between resumoBoleto'>
                  <div
                    className='centralized-space-evenly resumoBoleto__valortotal'
                    style={{
                      color: tema.primaryColor,
                      border: `2px solid ${tema.primaryColor}`,
                    }}
                  >
                    <div>
                      <span>Valor total: </span>
                      <b>
                        <span>
                          {Format(
                            dadosDesconto.totalBoleto -
                              dadosDesconto.totalDesconto
                          )}
                        </span>
                      </b>
                    </div>
                    <div
                      className='divisor'
                      style={{ backgroundColor: tema.primaryColor }}
                    ></div>
                    <div>
                      <span>Data de vencimento: </span>
                      <b>
                        {dataParaAgendar && (
                          <span>{formatData(dataParaAgendar)}</span>
                        )}
                      </b>
                    </div>
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      gerarBoleto().catch((e) => console.error(e));
                    }}
                    className='centralized'
                    style={{ backgroundColor: tema.primaryColor }}
                  >
                    <span>Gerar boleto</span>
                  </button>
                </div>
              </>
            )}
          </>
        </ContainerGerarBoleto>
      </BannerGerarBoleto>
    </>
  );
};

export default GerarBoleto;
